module.exports = __webpack_public_path__ + "img/Pigeon_icon.8b7fe401.png";